import React, { useState } from "react";
import { useForm, FormProvider } from "react-hook-form";
import { Link } from "react-router-dom";
import ActionMenuContainer from "../../ActionMenuContainer";
import Select from "../../../UI/Inputs/Select/Select";
import SelectItem from "../../../UI/Inputs/Select/SelectItem";
import Input from "../../../UI/Inputs/Input";
import Button from "../../../UI/Button";
import InputGroup from "../../../UI/Inputs/InputGroup";
import DatePickerInput from "../../../UI/Inputs/DatePickerInput";
import { updateEnrollmentRequest } from "../../../../requests/enrollments";
import { displayError } from "../../../../utils/displayError";
import { ToastNotification } from "../../../UI/ToastNotification";
import StudentSelect from "../StudentSelect";
import SeriesSelect from "../SeriesSelect";

export default function NewStudentReminder({ setRender, loaderStudent }) {
  const [student, setStudent] = useState(loaderStudent);
  const methods = useForm();
  const selectedEnrollmentId = methods.watch("selected_enrollment_id");

  const onSubmit = async (data) => {
    try {
      const res = await updateEnrollmentRequest({
        reminders_attributes: [
          {
            date: data.date,
            notes_attributes:
              data.note_text && data.note_type
                ? [
                    {
                      text: data.note_text,
                      type: data.note_type,
                    },
                  ]
                : [],
          },
        ],
        enrollmentId: selectedEnrollmentId,
      });

      if (res.data) {
        ToastNotification("success", "Reminder created successfully.");
        setRender(null);
      }
    } catch (e) {
      displayError(e);
    }
  };

  return (
    <ActionMenuContainer
      label="Add a reminder"
      handleGoingBack={() => setRender(null)}
    >
      <FormProvider {...methods}>
        <form
          onSubmit={methods.handleSubmit(onSubmit)}
          className="min-h-[400px]"
        >
          <StudentSelect onChange={setStudent} loaderStudent={loaderStudent} />

          {student && !student.accepted && (
            <p className="text-orange-500 [&_a]:text-blue-500 [&_a]:underline">
              You need to accept the student before continuing.{" "}
              <Link to={`/students/${student.id}/overview`}>View Student</Link>
            </p>
          )}
          {student && student.accepted && (
            <>
              <InputGroup>
                <SeriesSelect student={student} methods={methods} />

                <DatePickerInput
                  id="date"
                  dark
                  label="Sent"
                  selected={new Date()}
                  isRequired
                />
              </InputGroup>
              <InputGroup>
                <Select
                  id="note_type"
                  classNames="w-full bg-transparent"
                  label="Note Type"
                  isRequired={Boolean(methods.watch("note_text"))}
                >
                  <SelectItem value="">Select</SelectItem>
                  <SelectItem value="Note">Note</SelectItem>
                  <SelectItem value="PrayerRequest">Prayer Request</SelectItem>
                </Select>
                <Input id="note_text" label="Note" dark />
              </InputGroup>
              <div className="text-center">
                <Button type="submit" variant="primary">
                  Save Reminder
                </Button>
              </div>
            </>
          )}
        </form>
      </FormProvider>
    </ActionMenuContainer>
  );
}
